<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle font-weight-bold pl-10">
      {{ $t(selectBoxInfo.target) }}
    </div>
    <RequiredLabel class="ml-2" />

    <span class="d-flex align-center">
      <div class="selectBoxStyle">
        <v-text-field
          v-model="controlNumber"
          :placeholder="$t('common.input_input-sale-num')"
          dense
          filled
          hide-details
          height="32px"
        >
        </v-text-field>
      </div>
    </span>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import RequiredLabel from '@/components/items/Labels/RequiredLabel'

export default {
  components: {
    RequiredLabel
  },
  props: {
    target: { default: '' }
  },
  data: () => ({
    isEdit: false,
    controlNumber: '',

    selectClientName: {
      label: '',
      value: null
    },
    historySelectData: {
      selectClientName: {
        label: '',
        value: null
      },
      radioGroup: ''
    },
    selectBoxInfo: {
      target: 'refund.refund_refund-order',
      clientId: 'customerId',
      clientNameList: []
    },
    history: {
      headers: [
        {
          value: 'radioBtn',
          width: '55px',
          filterable: false,
          align: 'center'
        },
        {
          value: 'customerId',
          align: ' d-none'
        },
        {
          text: 'sale.sale_order-date',
          value: 'saleDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_completion-date',
          value: 'compDate',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_sale-number',
          value: 'transaction.controlNumber',
          width: '220px',
          filterable: false,
          align: 'center'
        },

        {
          text: 'sale.sale_author',
          value: 'user',
          width: '100px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'common.input_currency',
          value: 'currencyId',
          width: '80px',
          filterable: false,
          align: 'center'
        },
        {
          text: 'sale.sale_price',
          value: 'amount',
          width: '144px',
          filterable: false,
          align: 'end'
        }
      ],
      itemKey: 'saleId',
      items: []
    },
    dialog: {
      historySearch: false,
      registerMaster: false
    }
  }),
  async created() {
    this.isEdit = this.target ? true : false
    if (this.isEdit) return

    await this.init(false)
  },

  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapActions('Customer', ['getCustomersFromApi']),
    ...mapGetters('Customer', ['getCustomerListFromState']),
    ...mapActions('Sale', ['getSaleListFromApi']),
    ...mapGetters('Sale', ['getSaleListFromState']),

    getHistoryListFromState() {
      return this.getSaleListFromState()
    },
    getClientListFromState() {
      return this.getCustomerListFromState()
    },

    async getClientData(isHistorySearch, selectClientNameValue) {
      return await Promise.all([
        this.getCustomersFromApi(),
        isHistorySearch
          ? this.getSaleListFromApi({
              invalidSaleDisplay: 0,
              customerIds: selectClientNameValue
            })
          : null
      ]).then((message) => {
        return [
          this.getClientListFromState().map((ele) => {
            return {
              label: ele.organizationName,
              value: ele[this.selectBoxInfo.clientId]
            }
          }),
          isHistorySearch ? this.getHistoryListFromState() : []
        ]
      })
    },

    async changeHistorySearch(...args) {
      const [selectClientNameValue] = args
      await this.getSaleListFromApi({
        invalidSaleDisplay: 0,
        customerIds: selectClientNameValue
      })
      this.history.items = this.getHistoryListFromState()
    },
    async registerMasterSuccess() {
      await this.getCountryListFromApi()
      await this.init(false)
      this.dialog.registerMaster = false
    },

    async init(isHistorySearch) {
      const [clientNameList, historyList] = await this.getClientData(
        isHistorySearch,
        this.selectClientName.value
      )

      this.selectBoxInfo.clientNameList = clientNameList
      this.history.items = historyList
    },

    async historySearch() {
      if (!this.selectClientName.value) {
        alert(
          this.$t(this.selectBoxInfo.target) +
            this.$t('common.common_input-select')
        )
        return
      }
      await this.init(true)
      this.dialog.historySearch = true
    },

    reflect(...args) {
      const [selectClientName, radioGroup] = args

      const history = this.getHistoryListFromState().find(
        (ele) =>
          ele[this.selectBoxInfo.clientId] === selectClientName.value &&
          ele[this.history.itemKey] === radioGroup
      )
      const clientData = this.getClientListFromState().find(
        (ele) => ele[this.selectBoxInfo.clientId] === selectClientName.value
      )
      history.recipients = clientData ? clientData.recipients : []

      this.historySelectData = {
        selectClientName: selectClientName,
        radioGroup: radioGroup
      }
      this.selectClientName = selectClientName

      this.$emit('change', 'history', this.history.itemKey, history)
    }
  },
  watch: {
    controlNumber: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;

  .titleStyle {
    font-size: 18px;
  }

  .selectBoxStyle {
    width: 380px;
    margin: 0px 16px 0px 16px !important;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }
}
</style>
